const FREE_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "yahoo.com",
  "ymail.com",
  "hotmail.com",
  "outlook.com",
  "live.com",
  "msn.com",
  "aol.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "mail.com",
  "gmx.com",
  "gmx.net",
  "gmx.de",
  "zoho.com",
  "yandex.com",
  "yandex.ru",
  "mail.ru",
  "inbox.com"
]);

const PROTON_DOMAINS = new Set([
  "proton.me",
  "protonmail.com",
  "protonmail.ch",
  "pm.me"
]);

export function validateBusinessEmail(email: string): { isValid: boolean; error?: string } {
  if (!email || !email.includes("@")) {
    return { isValid: false, error: "Please enter a valid email address." };
  }

  const domain = email.split("@").pop()?.toLowerCase().trim();
  if (!domain) {
    return { isValid: false, error: "Invalid email domain structure." };
  }

  // Proton mail exception
  if (PROTON_DOMAINS.has(domain)) {
    return { isValid: true };
  }

  // Check if domain is blocked
  if (FREE_EMAIL_DOMAINS.has(domain)) {
    return { 
      isValid: false, 
      error: "Strategic onboarding requires a verified business email address. Generic free accounts (e.g. Gmail, Yahoo, Outlook) are restricted. Proton Mail is accepted." 
    };
  }

  return { isValid: true };
}
